import React from 'react'
// import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
// import Box from '@material-ui/core/Box'
// import InfoArea from '../../../components/common/InfoArea'
// import Typography from '@material-ui/core/Typography'
// import Hidden from '@material-ui/core/Hidden'
//style
// import featuresStyle from '../../../assets/jss/styles/featuresStyle'


// const useStyles = makeStyles(featuresStyle)

export default function iconCardNoBk(props) {
  // const { iconCardNoBks } = props;
  
  return (
    <>
    <Grid container justifyContent="center">
     {/* {iconCardNoBks.map((content, index) => (
        <Grid item xs={12} key={index}>
          <InfoArea
            // className={classes.infoArea}
            icon={content.icon}
            title={content.title}
            description={content.desc}
            iconColor={content.iconColor}
          />
        </Grid>
      ))}  */}
      </Grid>
    </>
  )
}



 